import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import draftStyles from "../draftStyles.css";
export const TextEditorCharacterCount = ({
  counterPlugin,
  editorState,
  characterCountLimit,
  countFunction,
  ...props
}) => {
  const {
    CharCounter,
    CustomCounter
  } = counterPlugin;
  const theme = useContext(ThemeContext);
  return React.createElement(TextEditorCharacterCountContainer, null, React.createElement(CustomCounter, {
    editorState: editorState,
    limit: characterCountLimit,
    counterOverLimit: draftStyles.counterLimitError,
    countFunction: countFunction
  }), "/", characterCountLimit);
};
export const TextEditorCharacterCountContainer = styled.p`
  padding-right: 5px;
  margin: auto 5px;
  ${props => props.theme.fonts.default}
  font-size: 12px;
`;